export default __webpack_public_path__ + "static/media/ilet.15273697.png";